import { render, staticRenderFns } from "./Graficas.vue?vue&type=template&id=1870c341"
import script from "./Graficas.vue?vue&type=script&lang=js"
export * from "./Graficas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports